import { Typography } from '@material-ui/core';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

type PromoPanelTickBoxProps = {
  children: React.ReactNode | React.ReactNodeArray;
  Icon: React.ReactNode;
  size?: 'small' | 'normal';
};

const useStyles = makeStyles((theme) => ({
  promoPanelRow: {
    display: 'flex',
    alignItems: 'center',
    '& > *:first-child': {
      marginRight: theme.spacing(3),
    },
    marginBottom: theme.spacing(1),
  },
}));

const sizes = {
  small: '14px',
  normal: '18px',
} as const;

export function PromoPanelRow({
  size = 'normal',
  ...props
}: PromoPanelTickBoxProps) {
  const classes = useStyles();

  return (
    <div className={classes.promoPanelRow}>
      {props.Icon}
      <Typography
        style={{
          fontSize: sizes[size],
          fontWeight: 300,
          flexShrink: 99999,
        }}
      >
        {props.children}
      </Typography>
    </div>
  );
}
